import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
// import About from "../views/About.vue";
import Login from "../views/Login.vue";
// import Register from "../views/Register.vue";
// import Questions from "../views/Questions.vue";
// import Results from "../views/Results.vue"
import Layout from "../components/Layout.vue";
import MyAss from "../views/MyAssessment/MyAssessment.vue";
import JKMyAss from "../views/MyAssessment/MyAssessment_JianKang.vue";
import RCMyAss from "../views/MyAssessment/MyAssessment_RC.vue";
import ChengShu from "../views/QuestionManagement/ChengShu.vue";
import JianKang from "../views/QuestionManagement/JianKang.vue";
import RenCai from "../views/QuestionManagement/RC.vue";
// import ChengShu_Todo from "../views/MyAssessment/ChengShu_todo.vue";
// import JianKang_Todo from "../views/MyAssessment/JianKang_todo.vue";
// import Progress from "../views/ProgressTracking/ProgressTracking.vue";
// import ChengShu_Progress from "../views/ProgressTracking/ChengShu_progress.vue";
// import Results from "../views/AssessResults/MyTakePartIn.vue";
import Tasks from "../views/QuestionManagement/ChengShu_taskmana.vue";
import JKTasks from "../views/QuestionManagement/JianKang_taskmana.vue";
// import ChengShu_TakePartIn from "../views/AssessResults/ChengShu_MyTakePartIn.vue";
// import JianKang_TakePartIn from "../views/AssessResults/JianKang_MyTakePartIn.vue";
// import MyOwnResults from "../views/AssessResults/MyOwnResults.vue";
// import ChengShu_OwnResults from "../views/AssessResults/ChengShu_OwnResults.vue";
// import VideoPlayer from "../views/VideoTest.vue";
import NF from "../components/NotFound.vue";
// import Report from "../views/MonthReport.vue";
import Company from "../views/CompanyUserDownload.vue";
import LoginJK from "../views/Login_JianKang.vue";
import LoginRC from "../views/Login_RC.vue";
import JK from "../components/Layout_JianKang.vue";
import RC from "../components/Layout_RC.vue";
import JKDataCenter from "../views/QuestionManagement/JianKang_DataCenter.vue";
import JKCompany from "../views/JKCompanyUserDownload.vue";
import RCTasks from "../views/QuestionManagement/RC_taskmana.vue";
import RCReports from "../views/AssessResults/RC_report_center.vue";
import AutoAnswer from "../views/AutoAnswer.vue";
import AutoTest from "../views/MultiAutoTest.vue";

Vue.use(VueRouter);
// 这里重写push方法（replace方法同理），重点就是后面的.catch(err => err) 用来捕获并隐藏报错。
// 在首页进行注销并跳转至首页时，因为前后是相同的路由，此时命令行会抛错，这里处理后就隐藏了报错。
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // {
  //   path: "/report",
  //   name: "Report",
  //   component: Report,
  //   // component: () => import('../views/Login.vue'),
  // },
  {
    path: "/login",
    name: "Login",
    component: Login,
    // component: () => import('../views/Login.vue'),
  },
  {
    path: "/JKlogin",
    name: "LoginJK",
    component: LoginJK,
    // component: () => import('../views/Login.vue'),
  },
  {
    path: "/RClogin",
    name: "LoginRC",
    component: LoginRC,
    // component: () => import('../views/Login.vue'),
  },
  {
    path: "/RC",
    name: "RC",
    component: RC,
    // redirect: '/RC/myass',
    // redirect: '/JK/myass',
    // component: () => import('../views/Login.vue'),
    children: [
      {
        path: "/RC/myass",
        name: "RCMyAss",
        component: RCMyAss,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '我的任务'},        
      },
      {
        path: "/RC/tasks",
        name: "RCTasks",
        component: RCTasks,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '任务管理'},        
      },
      {
        path: "/RC/taskmgmt",
        name: "RCTaskMgmt",
        component: RenCai,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '任务管理'},
      },
      {
        path: "/RC/reportCenter",
        name: "RCReports",
        component: RCReports,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '报表中心'},
      },
      {
        path: "/RC/autotest",
        name: "AutoTest",
        component: AutoTest,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '自动化批量测试'},
      },
    ]
  },
  {
    path: "/JK",
    name: "JK",
    component: JK,
    // redirect: '/JK/myass',
    // component: () => import('../views/Login.vue'),
    children: [
      {
        path: "/JK/myass",
        name: "JKMyAss",
        component: JKMyAss,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '我的任务'},        
      },
      {
        path: "/JK/tasks",
        name: "JKTasks",
        component: JKTasks,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '任务管理'},        
      },
      {
        path: "/JK/taskmgmt",
        name: "JKTaskMgmt",
        component: JianKang,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '任务管理'},
      },
      {
        path: "/JK/dataCenter",
        name: "JKDataCenter",
        component: JKDataCenter,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '数据中心'},
      },
      {
        path: "/JK/company",
        name: "JKCompany",
        component: JKCompany,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '企业用户中心'},
      },
      {
        path: "/JK/autotest",
        name: "AutoTest",
        component: AutoTest,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '自动化批量测试'},
      },
    ]
  },
  // {
  //   path: "/regist",
  //   name: "Register",
  //   component: Register,
  // },
  {
    path: "/",
    name: "Layout",
    component: Layout,
    // component: () => import('../components/Layout.vue'),
    redirect: '/myass',
    children: [
      {
        path: "/myass",
        name: "MyAss",
        component: MyAss,
        // component: () => import('../views/MyAssessment/MyAssessment.vue'),
        meta: {title: '我的评估'},
      },
      {
        path: "/taskmgmt",
        name: "TaskMgmt",
        component: ChengShu,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '任务管理'},
      },
      {
        path: "/company",
        name: "Company",
        component: Company,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '企业用户中心'},
      },
      {
        path: "/jiankang",
        name: "JianKang",
        component: JianKang,
        meta: {title: '组织健康度测评'},
      },
      // {
      //   path: "/progress",
      //   name: "Progress",
      //   component: Progress,
      //   meta: {title: '进度跟踪'},
      // },
      // {
      //   path: "/results",
      //   name: "Results",
      //   component: Results,
      //   meta: {title: '评估结果'},
      // },
      {
        path: "/tasks",
        name: "Tasks",
        component: Tasks,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '任务管理'},        
      },
      {
        path: "/auto_answer",
        name: "AutoAnswer",
        component: AutoAnswer,
      },
      // {
      //   path: "/video_player",
      //   name: "VideoPlayer",
      //   component: VideoPlayer,
      // },
      {
        path: "/autotest",
        name: "AutoTest",
        component: AutoTest,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '自动化批量测试'},
      },
    ]
  },
  // 设置404页面的路由
  {
    path: "/404",
    name: "notFound",
    component: NF,   
    // component: () => import('../components/NotFound.vue'),     
  },
  {
    path: "*",
    redirect: "/404"
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition){
    if (savedPosition) {
      return savedPosition
    }
    return {
      x: 0,
      y: 0
    }
  }
});

export default router;
